import { FC, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { browserSession } from '../services/utils/browserSession';

const AuthenticatedRoute: FC<{ children: ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const { user, isHydrating } = useAuth();
  const identity = browserSession.getIdentity();
  const verify = browserSession.getVerify();
  const hasContextUser = Boolean(user?.user?.id);
  const hasStoredIdentity = Boolean(identity?.user?.id);
  const hasVerifyToken = Boolean(user?.verifyToken || verify?.verifyToken);
  const hasValidSession = (hasContextUser || hasStoredIdentity) && hasVerifyToken;

  useEffect(() => {
    if (isHydrating) return;
    if (!hasValidSession) {
      navigate('/welcome', { replace: true });
    }
  }, [hasValidSession, isHydrating, navigate]);

  if (isHydrating || !hasValidSession || !hasContextUser) return null;

  return <>{children}</>;
};

export default AuthenticatedRoute;
